import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t-2 border-gray-200 text-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img 
                src="/images/logo.png" 
                alt="timcheh" 
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-sm text-gray-600">
              بزرگ‌ترین وب‌سایت رایگان آگهی‌های دسته‌بندی شده کانادا. با اطمینان خرید و فروش کنید.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">لینک‌های سریع</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  خانه
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  جستجوی آگهی‌ها
                </Link>
              </li>
              <li>
                <Link to="/post-ad" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  ثبت آگهی
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  مرکز راهنما
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">اطلاعات</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  حریم خصوصی
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  تماس با ما
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  سوالات متداول
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">قوانین</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms-of-use" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  شرایط استفاده
                </Link>
              </li>
              <li>
                <Link to="/rules" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  قوانین
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600">
              کپی‌رایت © وب‌سایت timcheh (۱۴۰۴). تمامی حقوق محفوظ است.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

